import styled from "styled-components";


export const Container = styled.div`
  /* display: flex; */
  flex-direction: column;
  padding: 25px 10px 25px 0px;
  /* margin-right:10px; */
  width: 100%;
  min-width: 0;
  box-sizing: border-box;

  @media screen and (max-width: 768px) {
    padding-right: 0;
  }
`
export const ButtonsWrapper = styled.div`
  display:flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  min-width: 0;
  &>div{
    display:flex;
    flex-direction: row;
    min-width: 0;
  }

  @media screen and (max-width: 768px) {
    flex-wrap: wrap;
    gap: 8px;

    > div {
      flex-wrap: wrap;
      gap: 8px;
    }
  }
`
